import Vue from 'vue'
import store from './store'
import i18n from './i18n';
import App from './App.vue'
import './utils/prototype.js'
import './utils/directive.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'vue-select/dist/vue-select.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
import './assets/index.css';

Vue.config.productionTip = false

new Vue({
    store,
    i18n,
    render: h => h(App),
    beforeMount() {
        this.$store.dispatch('settings/loadFromDataset', this.$el.dataset)
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.length !== 0) this.$store.dispatch('settings/loadFromUrl', urlParams)
        i18n.locale = this.$store.getters['settings/lang']
    }
}).$mount('#app-enrol')
